import LocalStorageService from "../LocalStorageService";

const RolesHelper = {
  getRole: () => ({}),
  getPagesVisibility() {
    const isAuthenticated = LocalStorageService?.get("authorizationData")
      ?.access
      ? true
      : false;

    return {
      is_checkout_visible: true,
      is_favorites_visible: isAuthenticated,
      is_reviews_visible: isAuthenticated,
      is_orders_visible: isAuthenticated,
      is_single_product_visible: true,
      is_profile_visible: isAuthenticated,
    };
  },
};

export default RolesHelper;
